import React from 'react';
import { Link } from 'react-router-dom';

const AccessDenied = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-red-100">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
        <div className="mb-6">
          <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="bi bi-shield-x text-5xl text-red-600"></i>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-gray-600 mb-6">
            You don't have permission to access the panel. This area is restricted.
          </p>
        </div>
        
        <div className="space-y-3">
          <a
            href="https://www.travellinglark.com"
            className="block w-full px-6 py-3 bg-[#009ef7] text-white rounded-lg hover:bg-[#009ef7]/90 transition-colors font-medium no-underline"
          >
            Go to Main Website
          </a>
          <Link
            to="/login"
            className="block w-full px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium no-underline"
          >
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
